<template>
  <div id="app">
    <div class="nav">
      <NavigationBar />
      <DocumentTitle />
      <CacheControl />
    </div>
    <div class="main">
      <router-view />
      <Footer />
      <InitialOfflineModal v-if="!wasOfflineModeInitialized" />
    </div>
    <ServiceWorker />
  </div>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
import { checkAllElementsForUpdate } from "@/services/caching/cachingHelpers.js";
import NavigationBar from "@/components/NavigationBar";
import CacheControl from "@/components/u/CacheControl";
import DocumentTitle from "@/components/u/DocumentTitle";
import ServiceWorker from "@/components/u/ServiceWorker";
import Footer from "@/sections/Footer";
import { isNeitherIeNorEdge } from "./services/browser";
import InitialOfflineModal from "@/components/InitialOfflineModal";
import { useToast } from "vue-toastification";
import ToastComponent from "@/components/ToastComponent";



export default {
  components: {
    CacheControl,
    DocumentTitle,
    NavigationBar,
    Footer,
    InitialOfflineModal,
    ServiceWorker,
  },
  setup() {
      const toast = useToast();
      return { toast }
    },
  
  data() {
    return {
      refreshing: false,
    };
  },
  beforeCreate() {
    this.$i18n.locale = languageAdapter.getLanguageOfUserFromPath(
      this.$route.params
    );
    this.$store.dispatch("setCachingStatus", ["de", "en"]);
    this.$store.commit("setPwaMode");
  },
  watch: {
    $route(to) {
      const lang = languageAdapter.getLanguageOfUserFromPath(to.params);
      this.$i18n.locale = lang;
      this.$store.commit("setLanguage", lang);
    }
  },
  mounted() {
    if (this.$store.state.isPwaModeActive) {
      if (this.$store.state.wasOfflineModeInitialized === "true") {
        this.checkIfElementsForThisLanguageAreCached();
      } 
      checkAllElementsForUpdate();
    } 

    this.$store.commit(
      "setLanguage",
      languageAdapter.getLanguageOfUserFromPath(this.$route.params)
    );
    this.checkIfIEOrEdge();
  },
  updated() {
    this.scrollToCurrentPage();
  },
  computed: {
    wasOfflineModeInitialized() {
      return this.$store.state.wasOfflineModeInitialized;
    },
    
  },
  methods: {
    scrollToCurrentPage: function() {
      var page = this.$route.params.page;
      if (page) {
        document.getElementById(page).scrollIntoView();
      }
    },
    async checkIfElementsForThisLanguageAreCached() {
      
      const { isCheckingCachedElements, language } = this.$store.state;

      if (isCheckingCachedElements) {
        setTimeout(() => {
          this.checkIfElementsForThisLanguageAreCached();
        }, 1000);
        return;
      }

      if (!this.$store.getters.isLanguageCached(language)) {

        this.toast({
          component: ToastComponent,
          props: {
              text: this.$t("files_arent_cached_for_selected_languageToast"),
              action: () => {
                        this.$store.commit("setIsSettingsModalopen", true);},
              actionName: this.$t("open_settings"),
              closeText: this.$t("close"),
            },

            }, { containerClassName: "my-container-class", toastClassName: "my-custom-toast-class", bodyClassName: ["custom-class-1"], })
      }
    },
    checkIfIEOrEdge() {
      this.$store.state.supportsPWAandFetch = isNeitherIeNorEdge;
    }
  }
};
</script>
<style>
@import "assets/css/animate.min.css";
@import "assets/css/bootstrap.min.css";
@import "assets/css/image-map-pro.min.css";
@import "assets/css/jquery.fancybox.min.css";
@import "assets/css/fonts.css";
@import "assets/css/keyframes.css";
@import "assets/css/style-xs.css";
@import "assets/css/style-s.css";
@import "assets/css/style-m.css";
@import "assets/css/style-l.css";
@import "assets/css/style-xl.css";
@import "assets/css/main_smoke.css";
#app {
  display: flex;
  flex-direction: column;
}
#app .nav {
  height: 90px;
}
#app .main {
  flex: 1;
  background: transparent;
}
.Vue-Toastification__toast-component-body.custom-class-1 {
        font-size: 15px;
        
    }
.Vue-Toastification__toast--default.my-custom-toast-class {
        width: 100%;
        top: 7em;
    }
  .toastText {
    font-size: 15px;
  }


@media only screen and (max-width: 600px) {
  .Vue-Toastification__toast-component-body.custom-class-1 {
        font-size: 12px;
        width: 100vw;
    }
 
    .Vue-Toastification__toast--default.my-custom-toast-class {
        width: 100vw !important;
        max-width: 100vw !important;
        top: 0em;
    }
    .toastText {
    font-size: 12px;
  }
}
</style>
